// extracted by mini-css-extract-plugin
module.exports = {"WithSection":"withSection_WithSection__2WG4p"};